// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { Messages } from './type';

const messages: Messages = {
  // A. Header & Footer
  Language: '繁體中文',
  A001: '我的學習',
  A002: '課程',
  A003: '實驗',
  A004: '登入',
  A005: 'Copyright {year} © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved.',
  A006: '聯絡我們：',
  A007: '服務條款',
  A008: '隱私權條款',
  A009: '常見問題',
  A010: '問題回報',
  A011: '挑戰',
  A012: '考試',

  // B. HomePage
  B001: 'Hello, {username} !',
  B002: '我的學習',
  B003: '課程紀錄',
  B004: '工作坊',
  B005: '課程',
  B006: '實驗',
  B007: '倒數 {timeString} 結束',
  B008: '課程時間：{totalDuration}',
  B009: '操作時限：',
  B010: '影片數量：{vodCount} 個',
  B011: '實驗數量：{labCount} 個',
  B012: '測驗數量：{assignCount} 個',
  B013: '課程等級：',
  B014: '授課語言：{lang}',
  B015: '開始時間：{timeString}',
  B016: '結束時間：{timeString}',
  B021: '類別',
  B022: '名稱',
  B023: '平台',
  B024: '程度',
  B025: '狀態',
  B026: '完成日期',
  B027: '您目前沒有任何課程或工作坊喲',
  B028: '前往探索',
  B029: '您還沒有上課紀錄喔，快去開始你的第一堂課吧！',
  B030: '前往我的課程',
  B031: '系統出現暫時性的錯誤，請點此{here}。{br}如還是無法解決，請返回首頁稍後再試',
  'B031-1': '重試',
  B032: '返回首頁',
  B033: '已完成',
  B034: '已結束',
  B035: '未完成',
  B036: '挑戰',
  B037: '挑戰數量：{challengeCount} 個',
  B038: '連結',
  B039: '前往',
  B040: '考試',
  B041: '考試時限：',
  B042: '選擇題數：{examMultiSelect} 題',
  B043: '問答題數：{examQna} 題',
  B044: '考試數量：{examCount} 個',
  B045: '實作紀錄',
  B046: '已通過',
  B047: '未通過',
  B048: '批改中',
  B049: '已結束',
  B050: '檢視',
  B051: '您還沒有{handsOnType}的紀錄喔，快去開始你的第一個{handsOnType}吧！',
  B052: '前往{handsOnType}列表',
  B053: '批改紀錄',
  B054: '已批改',
  B055: '待批改',
  B056: '受試者',
  B057: '批改時間',
  B058: '名稱 - 程度',
  B059: '前往 Bifrost',
  B060: `
    親愛的 ECV 同仁您好，{br}
    未來 elearning 將全採用 Microsoft AD 進行 SSO 登入，{br}
    建議您可以前往 Bifrost(SSO Portal) 進行第一次登入，{br}
    我們會將您的 elearning 帳號與 Bifrost 進行綁定，{br}
    並關閉原有的「帳號密碼」登入。{br}
    {pdfLink}
  `,
  B061: '本次登入不再提醒',
  B062: '前往 Bifrost',
  B063: '實體課',
  B064: '課程地點：{location}',

  // C. Course List & Lab List
  C001: '輸入有興趣的關鍵字，探索更多課程！',
  C002: '輸入有興趣的關鍵字，探索更多實驗！',
  C003: '主題',
  C004: '等級',
  C005: '找不到結果',
  C006: '課程 Courses',
  C007: '實驗 Labs',
  C008: '全部',
  C009: '輸入有興趣的關鍵字，探索更多挑戰！',
  C010: '挑戰 Challenges',
  C011: '輸入有興趣的關鍵字，探索更多考試！',
  C012: '考試 Training Test',

  // D. Workshop Page & CoursePage
  D001: '開放期間',
  D002: '開始課程',
  D003: '課程尚未開始',
  D004: '繼續課程',
  D005: '複習課程',
  D006: '開放時間已結束',
  D011: '課程時間：',
  D012: '影片數量：{count} 個',
  D013: '實驗數量：{count} 個',
  D014: '測驗數量：{count} 個',
  D015: '影片',
  D016: '實驗',
  D017: '測驗',
  D018: '已完成',
  D019: '工作坊的時間已經到囉，{br}點按離開將會返回您的首頁。',
  D020: '離開',
  D021: '工作坊時間已結束！',
  D022: '工作坊的時間已經到囉，{br}點按離開將會返回您的首頁。',
  D023: '離開',
  D024: '尚未取得課程',
  D025: '挑戰數量：{count} 個',
  D026: '挑戰',
  D027: '考試',
  D028: '考試數量：{count} 個',
  D029: '下載成績',
  D030: '下載成功{br}如未成功下載，請點擊',
  D031: '這裡',
  D032: '下載失敗{br}請稍後重試',
  D033: '請選擇學員，下載成績',
  D034: '確認',
  D035: '下載失敗{br}該學員尚無成績',
  D036: '全選',
  D037: '只有「challenge & exam」會有實作紀錄',
  D038: '此工作坊尚無學員',
  D039: '請選擇下載種類：',
  D040: '下載總完成度',
  D041: '下載學員個人成績',
  D042: '請選擇需下載之資料',
  D043: '僅下載課程總完成度',
  D044: '下載課程總完成度(含考試紀錄)',
  D045: '簽到',
  D046: '簽退',
  D047: '距離簽到時間',
  D048: '簽到剩餘時間',
  D049: '距離簽退時間',
  D050: '簽退剩餘時間',
  D051: '檢視簽到記錄',
  D052: '簽到時間:{br}{time}',
  D053: '簽退時間:{br}{time}',
  D054: '實作開放至: {timeString}',
  D055: '實作為實驗、挑戰、考試',

  // E. Lab Page
  E001: '兌換實驗',
  E002: '開始實驗',
  E003: '確定使用 Credit 開始嗎？',
  E004: '支付 Credit 開始實驗',
  E005: '{creditEl} {credit, plural, =0 {credit} =1 {credit} other {credits}}',
  E006: '您目前擁有 {creditEl} {credit, plural, =0 {credit} =1 {credit} other {credits}}',
  E007: '您目前只有 {creditEl} {credit, plural, =0 {credit} =1 {credit} other {credits}}',
  E008: '如欲使用請洽管理員 {managerEmail}',
  E009: '一次只能進行一個實驗或一場挑戰或一場考試。{br}{br}您目前有其他實驗／挑戰正在進行，請先完成後再回來。',
  E010: '前往進行中的實驗',
  E011: '您還有 {count} 次的免費實驗次數',
  E012: '前往管理主控台',
  'E012-2': '前往入口網站',
  E013: '便利貼',
  E014: '可以把常使用的資料內容複製在這，或是記錄下任何靈感。\n\n＊離開實驗後此處就會清空，如果內容很重要，請於關閉本頁面前另行保存。',
  E015: '本實驗目前無法提供使用，請選擇其他實驗。',
  E016: '返回列表',
  E017: '您的部署已完成',
  E018: '繼續步驟',
  E019: '實驗部署進行中',
  // E020: '',
  E021: '部署出現錯誤，請重新嘗試',
  // E022: '再次部署',
  E023: '實驗時間已結束！',
  E024: '希望本次實驗讓你對雲端世界有了更深的了解～{br}繼續探索更多吧！',
  E025: '離開',
  E026: 'Credit 是你擁有的貨幣資源，{br}可用來兌換實驗。',
  E027: '簡介',
  E028: '完成實驗！',
  E029: '工作坊',
  E030: '有開啟提示',
  E031: '無開啟提示',
  E032: '挑戰排行榜',
  E033: '名次',
  E034: '學員',
  E035: '最佳完成時間',
  E036: '提示次數',
  E037: '獲得最佳名次',
  E038: '本挑戰目前無法提供使用，請選擇其他挑戰。',
  E039: '兌換挑戰',
  E040: '開始挑戰',
  E041: '前往進行中的挑戰',
  E042: '此任務已通過！請點選按鈕進行下個任務。',
  E043: '恭喜完成所有任務，請結束挑戰並查看排行。',
  E044: '輸入您取得的 Token {br}以確認任務是否完成。',
  E045: '點擊檢查按鈕確認任務是否完成。',
  E046: '輸入 Token',
  E047: '下個任務',
  E048: '結束挑戰',
  E049: '檢查',
  E050: '*Token 錯誤',
  E051: '*任務未完成',
  E052: 'Credit 是你擁有的貨幣資源，{br}可用來兌換挑戰。',
  E053: '挑戰時間已結束！',
  E054: '點擊按鈕返回主頁面。{br}如需再次使用挑戰請從主頁面重新進入。',
  E055: '使用提示會影響排名，請謹慎使用。',
  E056: '．未使用者會在「無開啟提示」{br}．開啟任一提示會在「有開啟提示」',
  E057: '提示',
  E058: '解鎖',
  E059: '放棄挑戰',
  E060: '重設環境',
  E061: '重設環境可恢復至初始設定，但至多重設 2 次。',
  E062: '是否確認重設環境？{br}重設環境會清除先前操作記錄。',
  E063: '是否確認放棄挑戰？{br}本次記錄將不會被保存。',
  E064: '確定',
  E065: '取消',
  E066: '點擊以前往任務檢查。',
  E067: '開始任務',
  E068: '支付 Credit 開始挑戰',
  E069: '挑戰部署進行中',
  E070: '挑戰者須完成「所有的任務」才會紀錄該次的成績並列入排行榜中(每天結算更新)。',
  E071: '目前尚無排行紀錄',
  E072: '挑戰仍在部署中，請稍後再試',
  E073: '忙碌中，請稍後再試',
  E074: '資源部署中',
  E075: '部署完成！',
  E076: '部署失敗',
  E077: '如欲取得課程請洽：',

  // F. CourseContentPage ( VoD )
  F001: '課程列表',
  F002: '筆記',
  F003: '要從上次暫停的地方繼續播放嗎？',
  F004: '好',
  F005: '取消',
  F006: '課程正在子母畫面中播放',
  F007: '切換回主螢幕',
  F008: '寫下一些學習心得吧',
  F009: '儲存',
  F010: '該筆記已刪除',
  F011: '復原',
  F012: '您還沒有任何筆記唷。\n在下方記錄下一些學習心得吧！',
  F013: '實驗階段請動手做起來{br}前往 lab 實際操作看看吧！',
  F014: '前往 Lab 實作',
  F015: '繼續課程',
  F016: '恭喜你完成本課程！{br}繼續探索更多雲上世界吧',
  F017: '返回首頁',
  F018: '差一點就完成本課程囉！{br}把前面還沒完成的部分都上完吧～',
  F019: '繼續課程',
  F020: '我們提供了一些補充資料給您喔 試著點擊下方按鈕去看看吧 !',
  F021: '前往超連結',
  F022: '本課程目前無法使用如需使用本課程請洽：{managerEmail}',
  F023: '返回首頁',
  F024: '實驗：',
  F025: '本影片目前沒有提供字幕喔',
  F026: '來小試身手，透過隨堂測驗看看你了解了多少吧 !',
  F027: '下次再做',
  F028: '開始測驗',
  F029: '{currentQuestion}/{totalQuestions} 題',
  F030: '檢查答案',
  F031: '答案正確',
  F032: '下一題',
  F033: '答案錯誤',
  F034: '查看結果',
  F035: '測試結果',
  F036: '您答對了 {correctQuestions}/{totalQuestions}',
  F037: '正確率',
  F038: '再試一次',
  F039: '繼續課程',
  F040: '前往實作',
  F041: '挑戰： ',
  F042: '前往考試',
  F043: '考試：',
  // G. MemberCenter
  'credit': '{credit, plural, =0 {0 credit} =1 {# credit} other {# credits}}',
  G001: '使用者名稱',
  G002: '先生',
  G003: '小姐',
  G004: '出生日期',
  G005: '組織',
  G006: '權限身份',
  G007: '密碼變更',
  G008: '您的興趣',
  G009: '您有興趣的領域是什麼呢，選擇你的興趣以獲得最佳推薦。',
  G010: '會員中心',
  G011: '後台管理',
  G012: '登出',
  G013: '變更密碼',
  G014: '變更後請使用新密碼再次登入系統喔！',
  G015: '請輸入原始密碼',
  G016: '請輸入新密碼',
  G017: '密碼請包含8字元以上英文及數字',
  G018: '變更密碼',
  G019: '原始密碼不正確',
  G020: '新密碼需包含8字元以上的英文及數字',
  G021: '新密碼與舊密碼相同',
  G022: '重設密碼成功 !',
  G023: '下次請用新密碼登入喔!',
  G024: '關閉',
  G025: '重設密碼失敗',
  G026: '好像有什麼地方出錯了，請重新嘗試。',
  G027: '返回',
  G028: '性別',
  G029: '不顯示性別',
  G030: '原始密碼',
  G031: '新密碼',

  // H. Notification
  H001: '通知',
  H002: '您獲得 {total} 堂新的課程囉!',
  H003: '前往我的學習',
  H004: '您獲得 {total} 門新的工作坊囉！',
  H006: `Hi { name } , 歡迎加入 {organizationName}，
  讓我們一起遨遊雲端世界吧！`,
  H008: '我們已回覆您的問題囉，來看看吧。',
  H009: '前往回覆',
  H012: '您的身份已變更為{roleName}囉。',
  H013: '目前沒有任何通知唷',
  H014: '讀取中',
  H015: '恭喜考試（{examName}）結束囉！{br}請至「考試紀錄」中檢視成績。',
  H016: '{reviewee}已完成考試：{examName}{br}請前往進行批改。',
  H017: '前往批改',

  // I. Support (Problem) / Questionnaire
  I001: '嗨，歡迎來到問題回報中心，{br}讓我們了解您的困擾並協助您順利解決！',
  I002: '問題回報',
  I003: '請輸入問題主旨',
  I004: '請選擇發問類型',
  I005: '課程內容',
  I006: '技術及使用問題',
  I007: '感想回饋',
  I010: '其他',
  I011: '請在此描述您遇到的問題，越詳細越好，方便團隊快速協助您！',
  I012: '送出',
  I013: '問題紀錄',
  I014: '點擊或拖曳上傳圖片',
  I015: '發問成功！',
  I016: '已幫您送出問題囉，請靜候回覆，謝謝您的來信！',
  I017: '完成',
  I018: '發問失敗',
  I019: '好像哪裡出錯了，請點此{retry}。{br}如還是無法解決，請返回首頁稍後再試',
  'I019-1': '重試',
  I020: '返回首頁',
  I021: '輸入新回應',
  I022: '送出',
  I023: '刪除',
  I024: '已解決',
  I025: '如果問題已經解決，請點擊以下按鈕：',
  I026: '前',
  I027: '請在此輸入對於本次實作的回饋與意見',
  I028: '評分：',
  I029: '實作滿意度調查',
  I030: '恭喜您完成實作，邀請您針對本次實作進行評分，以及提供您寶貴的意見，作為我們改進及提升品質的基礎，謝謝！',
  I031: '拖曳圖片上傳到對話',
  I032: '圖片最多上傳五張',
  I033: '評分低於4顆星時，您的意見為必填',

  // J. Login & SignUp
  J001: '登入',
  J002: '使用您的 eCloudture 帳戶登入',
  J003: '帳戶信箱',
  J004: '密碼',
  J005: '忘記密碼',
  J006: '還沒有帳號嗎?',
  'J006-1': '建立帳戶',
  J007: '登入',
  J008: '請輸入您的帳戶信箱',
  J009: '帳號須符合信箱格式',
  J010: '請輸入密碼',
  J011: '帳號或密碼錯誤，請檢查後再次嘗試',
  J012: '建立帳戶',
  J013: '建立您專屬的 eCloudture 帳戶',
  J014: '使用者名稱',
  J015: '帳戶信箱',
  J016: '密碼',
  J017: '密碼請包含8字元以上英文及數字',
  J018: '登入',
  J019: '建立',
  J020: '建立帳戶即表示您同意我們的 {privacy} 及 {terms}。',
  'J020-1': '隱私權',
  'J020-2': '服務條款',
  J021: '請輸入您的使用者名稱',
  J022: '請輸入您的帳戶信箱',
  J023: '請輸入密碼',
  J024: '字數請設定在30字元以下',
  J026: '帳號須符合信箱格式',
  J027: '本帳號已被使用，請嘗試其他帳號',
  J028: '密碼請包含8字元以上英文及數字',
  J029: '建立帳戶失敗',
  J030: '好像有什麼地方出錯了，請重新嘗試。',
  J031: '重試',
  J032: '帳戶認證',
  J033: '我們已經發送一封認證信至 {br}{registeredEmail}{br} 請至信箱點擊連結完成帳戶啟用 !',
  J034: '返回登入',
  J035: '再次發送',
  J036: '您已重新發送過囉，將於30秒後才可再次發送',
  J037: '歡迎您 ! ',
  J038: '帳號已完成認證 !  您的帳號是',
  'J038-2': '現在，您可以前往 eCloudture 探索與學習， 請點按登入前往查看課程。',
  'J038-3': '感謝您的加入，祝您使用愉快 !',
  J039: '登入',
  J040: '返回登入',
  J041: '忘記密碼',
  J042: '輸入您曾註冊的電子信箱，我們將發送重設密碼信件給您',
  J043: '帳戶信箱',
  J044: '發送',
  J045: '帳號須符合信箱格式',
  J046: '信件已發送',
  J047: '信件已經發送至您的電子信箱囉，請查看信件並點按連結以重設密碼。',
  J048: '返回登入',
  J049: '再次發送',
  J050: '您已重新發送過囉，將於30秒後才可再次發送',
  J051: '重設密碼',
  J052: '輸入您欲重新設置的密碼',
  J053: '密碼',
  J054: '密碼請包含8字元以上英文及數字',
  J055: '重設',
  J056: '密碼請包含8字元以上英文及數字',
  J057: '重設密碼失敗',
  J058: '好像有什麼地方出錯了，請重新嘗試。',
  J059: '返回',
  J060: '重設密碼成功 !',
  J061: '下次請用新密碼登入喔!',
  J062: '前往首頁',
  J063: '此帳號尚未驗證成功，請至信箱點擊連結進行開通',
  J064: '認證出現問題，請回到 Bifrost 重新驗證。',
  'J064-1': '重試',
  J065: 'eCloudvalley 同仁需透過 Bifrost 登入。',
  J066: '登入驗證中...',
  J067: 'eCloudvalley 同仁不用註冊，請透過 Bifrost 登入。',
  J068: 'eCloudvalley 同仁可直接透過 Bifrost 登入，{br}不需重設密碼',
  J069: '仍要重設密碼',

  // K: Exam Page
  K001: '兌換題目',
  K002: '考試紀錄',
  K003: '提交',
  K004: 'Credit 是你擁有的貨幣資源，可用來兌換考試。',
  K005: '本考試目前無法提供使用，請選擇其他考試。',
  K006: '回到頂部',
  K007: '考試時長',
  K008: '參與人數',
  K009: '等級',
  K010: '選擇題數',
  K011: '分鐘',
  K012: '確認要提交考試嗎？',
  K013: '有題目尚未作答',
  K014: '您目前有其他考試正在進行，請先完成後再回來。',
  K015: '開始考試',
  K016: '前往進行中的考試',
  K017: '合格分數',
  K018: '問答題數',
  K019: '上傳檔案',
  K020: '受試者：',
  K021: '考試名稱：',
  K022: '選擇題分數：',
  K023: '正確題數：',
  K024: '錯誤題數：',
  K025: '選擇題',
  K026: '問答題',
  K027: '總分',
  K028: '總題數',
  K029: '每題',
  K030: '分',
  K031: '回答：',
  K032: '分數：',
  K033: '評論：',
  K034: '確認要提交成績嗎？',
  K035: '您已提交此考試評分',
  K036: '您的網址有誤，無法找到正確的考試記錄',
  K037: '不能超過 {limitScore} 分',
  K038: '總檔案大小超過 6 MB，請壓縮檔案',
  K039: '考試狀態：',
  K040: '問答總分：',
  K041: '您的給分：',
  K042: '不能輸入超過5000個字',
  K043: '檔案不可超過 6MB',

  // Landing Page
  M002: '最貼近你的雲端培訓專家',
  M003: '免費開始',
  M005: 'Hands-on lab 的實作體驗帶您進入專屬的實驗情境{br}透過詳細的交戰手冊引導您一步步完成實驗{br}實驗室無須額外綁訂信用卡，也不必擔心用量超額以致費用暴增{br}經過完整的學習旅程與實作，您將對課程更了解並掌握關鍵概念',
  M006: '多雲學習',
  M007: '我們提供全球兩大雲平台 AWS , Azure 的課程與多雲應用與串接，透過不同雲端平台找尋最適合您的雲端學習歷程，並藉由實作與影片一步步走向雲的世界。',
  M008: '七大領域',
  M009: '在七大領域課程中，您可以根據自己的興趣來選擇，我們也提供了不同角色的學習路徑，讓您能夠輕鬆開始您的學習旅程。',
  M017: '全球化學習',
  M018: 'eCloudture 服務據點涵蓋了台灣及東南亞各國，提供中英雙語教學。{br}未來也將持續提供更多語言，以達到學習無國界的目標，{br}讓更多人可以透過 eCloudture elearning platform 認識雲端、學習雲端。',
  M024: '立即開始您的雲端之旅！',
  M025: '立即註冊',
  M026: '聯絡信箱',
  M027: '服務條款',
  M028: '隱私權條款',
  M029: '常見問題',
  // General
  Z001: '倒數 {day} 天 {hour} 小時 結束',
  'Z001-1': '倒數 {hour} 小時 {minute} 分 結束',
  'Z001-2': '倒數 {minute} 分 {second} 秒 結束',
  Z002: '入門',
  Z003: '基礎',
  Z004: '進階',
  Z005: '實戰',
}

export { messages as default }
